import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { getSnapshotList } from '../actions/api'
import { clearSelectedToken, clearTokenEnquire, changeSearchState, setSnapshotList, setModifyingDateTimeArray, setTokenEnquire, setSelectedSnapshotIndex } from '../actions/localStates'
import { formatDate, formatDateForCalendar } from '../actions/helpers'

import ActiveKeysView from './ActiveKeysView'
import WaitingKeysView from './WaitingKeysView'
import OtherKeysView from './OtherKeysView'
import OtherCertificatesView from './OtherCertificatesView'
import OtherCertificatesRequestsView from './OtherCertificatesRequestsView'

import RemovedTokenView from './RemovedTokenView'

class TokenView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	snapshotDate: "",
	    	modifyingDateTime: null,
			modifyingInitiatorId: null,
			showSnapshotList: false
	    }

	    this.snapshotDate = React.createRef();
	    this.calendarSnapshotRef = React.createRef();

	    this.getSnapshots = this.getSnapshots.bind(this);
	    this.onSnapshotDateChanged = this.onSnapshotDateChanged.bind(this);

	    this.getPreviousSnapshot = this.getPreviousSnapshot.bind(this);
	    this.getNextSnapshot = this.getNextSnapshot.bind(this);
	    this.getFirstSnapshot = this.getFirstSnapshot.bind(this);

	    this.findDifferences = this.findDifferences.bind(this);
	    this.setShowSnapshotList = this.setShowSnapshotList.bind(this);

	    this.closeSnapshotList = this.closeSnapshotList.bind(this);
	}

	setShowSnapshotList (event) {
		event.preventDefault();
		this.setState({
				showSnapshotList: !this.state.showSnapshotList
			}, () => {
			document.addEventListener('click', this.closeSnapshotList);
		});
  	}

	componentDidMount() {
		var dateArray = [], _this = this, urlString = "";

		if (this.props.tokenList.tokenEnquire !== null) {
			var data = {
				"uri": this.props.tokenList.tokenEnquire.uri,
			    "operator" : null,
			    "modifyingDateTimeNotBefore": null,
			    "modifyingDateTimeNotAfter": null
			}
			this.props.actions.getSnapshotList(this.props.base.serviceUrl, data, this.props.login.accessToken, urlString)
			.then((response) => {
				if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
	                this.props.actions.setErrorResponse(response.json)
					this.setState({showErrorPopup: true})
	                return
	            }

	            if (response.content.length > 0) {
	            	if (response.content.length < response.page.totalElements) {
	            		urlString = "?page=0&size=" + response.page.totalElements
	            	} else {
	            		urlString = ""
	            	}
	            	
	            	this.props.actions.getSnapshotList(this.props.base.serviceUrl, data, this.props.login.accessToken, urlString)
	            	.then((response) => {
						if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
			                this.props.actions.setErrorResponse(response.json)
							this.setState({showErrorPopup: true})
			                return
			            }

			            this.props.actions.setSnapshotList(response.content)
						response.content.forEach((element) => {
							dateArray.push(_this.props.actions.formatDateForCalendar(element.modifyingDateTime))
						})

						this.setState({"snapshotDate": _this.props.actions.formatDateForCalendar(response.content[0].modifyingDateTime)})
						this.setState({"modifyingDateTime": response.content[0].modifyingDateTime})
						this.setState({"modifyingInitiatorId": response.content[0].modifyingInitiatorId})
						var enquire = JSON.parse(response.content[0].vtokenJson)
						// this.props.actions.clearTokenEnquire()
						window.setTimeout(function () {
			            	_this.props.actions.setTokenEnquire(enquire)
			            }, 25)
						this.props.actions.setSelectedSnapshotIndex(0)

						this.props.actions.setModifyingDateTimeArray(dateArray)
						console.log(response)
			        })
	            	
	            }
			})
		}
		
	}

	componentWillUnmount() {

	}

	onSnapshotDateChanged (d) {
		var _this = this;
		var tempDate = d.setHours(0, 0, 0, 0)
		console.log(tempDate)
		for (var i = 0; i < this.props.tokenList.modifyingDateTimeArray.length; i += 1) {
			var subItem = this.props.tokenList.modifyingDateTimeArray[i].setHours(0, 0, 0, 0)

			if (tempDate === subItem) {
				console.log(i)
				var enquire = JSON.parse(_this.props.tokenList.snapshotList[i].vtokenJson)
				this.props.actions.clearTokenEnquire()
				this.props.actions.setTokenEnquire(enquire)
				this.props.actions.setSelectedSnapshotIndex(i)
				this.setState({"modifyingDateTime": _this.props.tokenList.snapshotList[i].modifyingDateTime})
				this.setState({"modifyingInitiatorId": _this.props.tokenList.snapshotList[i].modifyingInitiatorId})
				break;
			}
		}
        this.setState({"snapshotDate": d})
    }

	getSnapshots () {
		var data = {
			"uri": this.props.tokenList.tokenEnquire.uri,
		    "operator" : null,
		    "modifyingDateTimeNotBefore": null,
		    "modifyingDateTimeNotAfter": null
		}
		this.props.actions.getSnapshotList(this.props.base.serviceUrl, data, this.props.login.accessToken)
		.then((response) => {
			console.log(response)
		})
	}

	findDifferences(obj1, obj2, path = "") {
	  const changes = [];
	  const keys = new Set([...Object.keys(obj1 || {}), ...Object.keys(obj2 || {})]);

	  for (let key of keys) {
	    const fullPath = path ? `${path}.${key}` : key;
	    const val1 = obj1 ? obj1[key] : undefined;
	    const val2 = obj2 ? obj2[key] : undefined;

	    // Обидва null або undefined → пропускаємо
	    if (val1 == null && val2 == null) continue;

	    // Якщо типи різні — одразу фіксуємо зміну
	    if (typeof val1 !== typeof val2) {
	      changes.push({ field: fullPath, oldValue: val1, newValue: val2 });
	      continue;
	    }

	    // Якщо обидва — масиви
	    if (Array.isArray(val1) && Array.isArray(val2)) {
	      if (val1.length !== val2.length) {
	        changes.push({ field: fullPath, oldValue: val1, newValue: val2 });
	      } else {
	        for (let i = 0; i < val1.length; i++) {
	          const item1 = val1[i];
	          const item2 = val2[i];
	          if (typeof item1 === "object" && typeof item2 === "object") {
	            changes.push(...this.findDifferences(item1, item2, `${fullPath}[${i}]`));
	          } else if (item1 !== item2) {
	            changes.push({ field: `${fullPath}[${i}]`, oldValue: item1, newValue: item2 });
	          }
	        }
	      }
	      continue;
	    }

	    // Якщо обидва — об’єкти (не масиви)
	    if (
	      typeof val1 === "object" &&
	      val1 !== null &&
	      typeof val2 === "object" &&
	      val2 !== null
	    ) {
	      changes.push(...this.findDifferences(val1, val2, fullPath));
	      continue;
	    }

	    // Прості значення
	    if (val1 !== val2) {
	      changes.push({ field: fullPath, oldValue: val1, newValue: val2 });
	    }
	  }

	  return changes;
	}

	componentDidUpdate(prevProps) {
    	// if (prevProps.tokenList.tokenEnquire !== this.props.tokenList.tokenEnquire) {
	    //   const diffs = this.findDifferences(
	    //     prevProps.tokenList.tokenEnquire,
	    //     this.props.tokenList.tokenEnquire
	    //   );

	    //   if (diffs.length > 0) {
	    //     console.log("Зміни у data:");
	    //     diffs.forEach((d) => {
	    //       console.log(`${d.field}: ${d.oldValue} -> ${d.newValue}`);
	    //     });
	    //   }
	    // }
    }

	getPreviousSnapshot () {
		var _this = this;
		var enquire, prevDate;
		if ((this.props.tokenList.selectedSnapshotIndex + 1) < this.props.tokenList.snapshotList.length) {
			enquire = JSON.parse(this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex + 1].vtokenJson)
			this.props.actions.clearTokenEnquire()
			window.setTimeout(function () {
            	_this.props.actions.setTokenEnquire(enquire)
            }, 25)
			this.props.actions.setSelectedSnapshotIndex(this.props.tokenList.selectedSnapshotIndex + 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex + 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex + 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex + 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		} else {
			enquire = JSON.parse(this.props.tokenList.snapshotList[this.props.tokenList.snapshotList.length - 1].vtokenJson)
			this.props.actions.clearTokenEnquire()
			window.setTimeout(function () {
            	_this.props.actions.setTokenEnquire(enquire)
            }, 25)
			this.props.actions.setSelectedSnapshotIndex(this.props.tokenList.snapshotList.length - 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.tokenList.snapshotList[this.props.tokenList.snapshotList.length - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.tokenList.snapshotList[this.props.tokenList.snapshotList.length - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.tokenList.snapshotList[this.props.tokenList.snapshotList.length - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		}

		this.setState({"snapshotDate": prevDate})
	}
	
	getNextSnapshot () {
		var _this = this;
		var enquire, nextDate;
		if ((this.props.tokenList.selectedSnapshotIndex - 1) <= 0) {
			enquire = JSON.parse(this.props.tokenList.snapshotList[0].vtokenJson)
			this.props.actions.clearTokenEnquire()
			window.setTimeout(function () {
            	_this.props.actions.setTokenEnquire(enquire)
            }, 25)
			
			this.props.actions.setSelectedSnapshotIndex(0)
			nextDate = this.props.actions.formatDateForCalendar(this.props.tokenList.snapshotList[0].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.tokenList.snapshotList[0].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.tokenList.snapshotList[0].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		} else {
			enquire = JSON.parse(this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex - 1].vtokenJson)
			this.props.actions.clearTokenEnquire()
			window.setTimeout(function () {
            	_this.props.actions.setTokenEnquire(enquire)
            }, 25)
			this.props.actions.setSelectedSnapshotIndex(this.props.tokenList.selectedSnapshotIndex - 1)
			nextDate = this.props.actions.formatDateForCalendar(this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		}

		this.setState({"snapshotDate": nextDate})
	}

	handleReturn () {
		this.props.actions.setSnapshotList([])
		this.props.actions.clearTokenEnquire()
		this.props.actions.clearSelectedToken()
		this.props.actions.changeSearchState(false);
	}

	closeSnapshotList(event) { 
		this.setState({ showSnapshotList: false }, () => {
			document.removeEventListener('click', this.closeSnapshotList);
		});  
	}

	changeCurrentSnapshot (index) {
		var _this = this;
		var enquire = JSON.parse(this.props.tokenList.snapshotList[index].vtokenJson)
		this.props.actions.clearTokenEnquire()
		window.setTimeout(function () {
        	_this.props.actions.setTokenEnquire(enquire)
        }, 25)
		// this.props.actions.setTokenEnquire(enquire)
		this.props.actions.setSelectedSnapshotIndex(index)
	}

	getFirstSnapshot () {
		var _this = this;
		var enquire = JSON.parse(this.props.tokenList.snapshotList[0].vtokenJson)
		this.props.actions.clearTokenEnquire()
		window.setTimeout(function () {
        	_this.props.actions.setTokenEnquire(enquire)
        }, 25)
		this.props.actions.setSelectedSnapshotIndex(0)
	}

	render() {
		let showSnapshotListOpen = 'dropdown-menu'
	    if (this.state.showSnapshotList) {
	      showSnapshotListOpen = 'dropdown-menu show'
	    }
		return (
			<div>
				{
					this.props.base.activeTab === "removed"
					? <RemovedTokenView />
					: <div className="token-container">
						<div className="return-div">
							<button className="btn btn-outline-info" style={{marginTop: "10px", marginLeft: "10px"}} onClick={this.handleReturn.bind(this)}>
								<i className="fa fa-arrow-circle-left" style={{color: "#1C92C7", fontSize: "1.2em"}}></i>
								&nbsp;<span style={{fontSize: "18px"}}>{i18next.t("returnLabel")}</span>
							</button>
							{
								this.props.tokenList.snapshotList.length > 0
								? <div style={{float: "right", marginLeft: "auto", marginTop: "10px"}}>
									<div className="row no-right-padding" style={{paddingRight: "5px"}}>

										<div className="dropdown" style={{paddingLeft: "0px", paddingRight: "5px"}}>
                                            <button className="btn btn-outline-info" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" onClick={this.setShowSnapshotList}>
                                                <label className="text-overflow-label" style={{marginBottom: "0px"}}>{i18next.t("version")}{this.props.tokenList.snapshotList.length - this.props.tokenList.selectedSnapshotIndex}<span className="paddingLeft10">{i18next.t("dateTime")}</span>{this.props.actions.formatDate(this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex] !== undefined ? this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex].modifyingDateTime : null)}<span className="paddingLeft10">{i18next.t("issuerLabel")}</span>{this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex] !== undefined ? this.props.tokenList.snapshotList[this.props.tokenList.selectedSnapshotIndex].modifyingInitiatorId : ""}</label>
                                            </button>
                                            <div className={showSnapshotListOpen} style={{width: "100%", overflowY: "auto", maxHeight: "500px", fontSize: "14px"}}>
                                                {
                                                    <table className="table table-striped" style={{marginBottom: "0px"}}>
													  <tbody>
													    {this.props.tokenList.snapshotList.map((snapshot, index) => (
													      <tr key={index} className="cursor-pointer" onClick={this.changeCurrentSnapshot.bind(this, index)}>
													        <td style={{paddingLeft: "5px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("version")}</span>{(this.props.tokenList.snapshotList.length - index)}</td>
													        <td style={{paddingLeft: "20px"}}><span style={{fontWeight: "700"}}>{i18next.t("dateTime")}</span>{this.props.actions.formatDate(snapshot.modifyingDateTime)}</td>
													        <td style={{paddingLeft: "0px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("issuerLabel")}</span>{snapshot.modifyingInitiatorId}</td>
													      </tr>
													    ))}
													  </tbody>
													</table>
                                                }
                                            </div>
                                        </div>

										<button className="btn btn-outline-info" title={i18next.t("actual")} style={{marginRight: "5px"}} disabled={this.props.tokenList.selectedSnapshotIndex === 0 ? true : false} onClick={this.getFirstSnapshot}>{"|<"}</button>
				                        <button className="btn btn-outline-info" title={i18next.t("next")} style={{marginRight: "5px"}} disabled={this.props.tokenList.selectedSnapshotIndex === 0 ? true : false} onClick={this.getNextSnapshot}>{"<"}</button>
				                        <button className="btn btn-outline-info" title={i18next.t("previous")} style={{marginRight: "5px"}} disabled={this.props.tokenList.selectedSnapshotIndex === this.props.tokenList.snapshotList.length - 1 ? true : false} onClick={this.getPreviousSnapshot}>{">"}</button>

				                        {/*<div className="col-7 no-left-right-margin">
				                            <div className="customDatePickerWidth">
				                            <DatePicker ref={this.calendarSnapshotRef} includeDates={this.props.tokenList.modifyingDateTimeArray} highlightDates={this.props.tokenList.modifyingDateTimeArray} dateFormat="dd.MM.yyyy" maxDate={new Date()} className="form-control pointer" onClick={() => {this.calendarSnapshotRef.current.setOpen(true)}}
				                                selected={this.state.snapshotDate}
				                                onChange={this.onSnapshotDateChanged} />
				                            </div>
				                        </div>
				                        <div className="col-2 no-left-right-margin">
				                            <img className="img" onClick={() => {this.calendarSnapshotRef.current.setOpen(true)}} style={{cursor: "pointer"}}width="50px" height="40px" src={calenderIcon} alt="calenderIcon" />
				                        </div>*/}
				                    </div>
				                    {/*<div className="no-left-right-margin">
			                        	<div className="no-left-right-margin">{i18next.t("modifyingDateTime")}&nbsp;{this.props.actions.formatDate(this.state.modifyingDateTime)}</div>
			                        	<div className="no-left-right-margin">{i18next.t("modifyingInitiatorId")}&nbsp;{this.state.modifyingInitiatorId}</div>
			                        </div>*/}
				                </div>
								: null
							}
							
						</div>
						
						<div className="token-view">
							<div style={{paddingLeft: "10px", paddingRight: "10px"}}>
							{
								this.props.tokenList.list[this.props.tokenList.selectedToken] && this.props.tokenList.tokenEnquire !== null
								? <div>
									<div style={{paddingLeft: "0px", paddingRight: "0px", marginTop: "10px"}} className={this.props.tokenList.tokenEnquire.status === "BLOCKED" ? "table-border-blocked row col-lg-12 col-md-12 col-sm-12 col-xs-12" : "table-border row col-lg-12 col-md-12 col-sm-12 col-xs-12"}>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-3">
											<div className="table-header">
												<label>{i18next.t("tokenName")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label>{this.props.tokenList.tokenEnquire.title}</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-2">
											<div className="table-header">
												<label>{i18next.t("tokenUri")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label>
													{
														this.props.tokenList.tokenEnquire.uri
													}
												</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-3">
											<div className="table-header">
												<label>{i18next.t("tokenStatus")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label>
														{i18next.t(this.props.tokenList.tokenEnquire.status)}
												</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-3">
											<div className="table-header">
												<label>{i18next.t("tokenChangedDate")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												{
													<label>
														{
															this.props.actions.formatDate(this.props.tokenList.tokenEnquire.statusChangeDateTime)
														}
													</label>
												}
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-3">
											<div className="table-header">
												<label>{i18next.t("confidants")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{textAlign: "left"}}>
												{	
													(this.props.tokenList.tokenEnquire.confidants !== null && this.props.tokenList.tokenEnquire.confidants !== undefined && this.props.tokenList.tokenEnquire.confidants.length > 0)
													? this.props.tokenList.tokenEnquire.confidants.map((confidant) => {
														return(<label className="col-12" style={{marginBottom: "0px"}}>
															{
																confidant.commonName
															}
														</label>)
													})
													: null
												}
											</div>
										</div>
									</div>
								</div>
								: null
							}

			                <ActiveKeysView />
			                <WaitingKeysView />
			                <OtherKeysView />
			                <OtherCertificatesView />
			                <OtherCertificatesRequestsView />
			                
						</div>
						</div>
					</div>
				}
			</div>
			
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer,
        tokenList: state.tokenListReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	clearSelectedToken, formatDate, clearTokenEnquire,
    	changeSearchState, getSnapshotList, setSnapshotList,
    	formatDateForCalendar, setModifyingDateTimeArray,
    	setTokenEnquire, setSelectedSnapshotIndex
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenView);